import { render, staticRenderFns } from "./goodsClass.vue?vue&type=template&id=4201ecb3&scoped=true"
import script from "./goodsClass.vue?vue&type=script&lang=js"
export * from "./goodsClass.vue?vue&type=script&lang=js"
import style0 from "./goodsClass.vue?vue&type=style&index=0&id=4201ecb3&prod&lang=css"
import style1 from "./goodsClass.vue?vue&type=style&index=1&id=4201ecb3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4201ecb3",
  null
  
)

export default component.exports